import { IconName } from "shared/ui/icon/__generated__/IconName"

export function benefitsWidgetIconColor(icon: IconName) {
  switch (icon) {
    case IconName.CHECK:
      return "green-icon"
    case IconName.CLOSE:
      return "red-icon"
    case IconName.QUESTION:
      return "orange-icon"
    default:
      return ""
  }
}
